import { useState, useEffect, useRef } from "react"
import { collection, collectionGroup, getDocs, getDoc, doc, updateDoc,
         deleteDoc, addDoc, setDoc } from "firebase/firestore"
import { db } from "../services/firebase"
import { useAuth } from "../context/AuthContext"
import SubirVoucher from "../components/admin/SubirVoucher"
import CargarPuntos, { calcularTotalPuntos, calcularDescuentoUSD } from "../components/admin/CargarPuntos"
import ImportadorCSV from "../components/admin/ImportadorCSV"
import ImportadorViajes from "../components/admin/ImportadorViajes"
import { parsearFecha, formatFecha } from "../utils/adminConstants"
import { enviarEmailAdminCheckin, enviarEmailClienteCheckin } from "../utils/emailService"
import "./Admin.css"

import SeccionEstadisticas from "../components/admin/SeccionEstadisticas"
import SeccionConfiguracion from "../components/admin/SeccionConfiguracion"
import Modal from "../components/admin/Modal"
import ModalViaje from "../components/admin/ModalViaje"
import { ModalNuevoCliente, ModalEditarCliente } from "../components/admin/ModalCliente"
import SeccionResumen    from "../components/admin/SeccionResumen"
import SeccionClientes   from "../components/admin/SeccionClientes"
import SeccionViajes     from "../components/admin/SeccionViajes"
import SeccionAgenda     from "../components/admin/SeccionAgenda"
import SeccionCumpleanos from "../components/admin/SeccionCumpleanos"
import SeccionVincular   from "../components/admin/SeccionVincular"

// ─────────────────────────────────────────────────
// Toast de emails enviados (feedback visual)
// ─────────────────────────────────────────────────
function ToastEmailsEnviados({ emails, onCerrar }) {
  useEffect(()=>{ const t=setTimeout(onCerrar,6000); return()=>clearTimeout(t) },[])
  return (
    <div style={{ position:"fixed", bottom:"24px", right:"24px", zIndex:2000, background:"#0a2a1a", border:"1px solid #10b98160", borderRadius:"12px", padding:"16px 20px", maxWidth:"360px", boxShadow:"0 8px 32px rgba(0,0,0,0.4)" }}>
      <div style={{ fontWeight:700, color:"#10b981", marginBottom:"8px", fontSize:"0.9rem" }}>
        📧 {emails.length} email{emails.length!==1?"s":""} de check-in enviado{emails.length!==1?"s":""}
      </div>
      <div style={{ display:"flex", flexDirection:"column", gap:"4px" }}>
        {emails.map((e,i)=>(
          <div key={i} style={{ fontSize:"0.8rem", color:"#9ca3af" }}>✓ {e}</div>
        ))}
      </div>
      <button onClick={onCerrar} style={{ position:"absolute", top:"10px", right:"12px", background:"none", border:"none", color:"#4b5563", cursor:"pointer", fontSize:"0.9rem" }}>✕</button>
    </div>
  )
}

// ─────────────────────────────────────────────────
// Selector de cliente para nueva venta
// ─────────────────────────────────────────────────
function SelectorClienteVenta({ clientes, onSeleccionar, onCrearNuevo }) {
  const [busqueda,setBusqueda]=useState("")
  const filtrados=clientes.filter(c=>(c.nombre+" "+c.apellido).toLowerCase().includes(busqueda.toLowerCase())).sort((a,b)=>(a.nombre+" "+a.apellido).localeCompare(b.nombre+" "+b.apellido))
  return (
    <Modal titulo="Nueva venta" subtitulo="Selecciona el cliente" onCerrar={()=>onSeleccionar(null)} ancho="480px">
      <div style={{ marginBottom:"12px" }}>
        <input autoFocus className="admin__busqueda" placeholder="Buscar cliente..." value={busqueda} onChange={e=>setBusqueda(e.target.value)} style={{ width:"100%",marginBottom:"10px" }}/>
        <button onClick={onCrearNuevo} style={{ width:"100%",padding:"10px 14px",background:"#0a2a1a",border:"1px solid #10b98140",borderRadius:"8px",color:"#10b981",fontFamily:"Inter, sans-serif",fontSize:"0.875rem",fontWeight:700,cursor:"pointer",textAlign:"left" }}>
          + Crear nuevo cliente
        </button>
      </div>
      <div style={{ display:"flex",flexDirection:"column",gap:"6px",maxHeight:"420px",overflowY:"auto" }}>
        {filtrados.map(c=>(
          <button key={c.id} onClick={()=>onSeleccionar(c)} style={{ padding:"12px 14px",textAlign:"left",background:"#1a1a1a",border:"1px solid #2a2a2a",borderRadius:"8px",color:"#9ca3af",fontFamily:"Inter, sans-serif",fontSize:"0.875rem",cursor:"pointer",transition:"all 0.1s" }}
            onMouseEnter={e=>{e.currentTarget.style.borderColor="#3b82f6";e.currentTarget.style.color="#3b82f6"}}
            onMouseLeave={e=>{e.currentTarget.style.borderColor="#2a2a2a";e.currentTarget.style.color="#9ca3af"}}>
            <span style={{ fontWeight:600 }}>{c.nombre} {c.apellido}</span>
            <span style={{ fontSize:"0.75rem",opacity:0.5,marginLeft:"8px" }}>{c.ciudad||""}</span>
          </button>
        ))}
        {filtrados.length===0&&<div style={{ textAlign:"center",padding:"20px",color:"#4b5563",fontSize:"0.875rem" }}>Sin resultados.</div>}
      </div>
    </Modal>
  )
}

function SelectorCliente({clientes,seleccionado,onSeleccionar,colorActivo}){const [b,setB]=useState(""),color=colorActivo||"#3b82f6",f=clientes.filter(c=>(c.nombre+" "+c.apellido).toLowerCase().includes(b.toLowerCase()));return(<div className="admin__card"><div className="admin__card-header"><div className="admin__card-titulo">Seleccionar cliente</div></div><div style={{ padding:"16px" }}><input className="admin__busqueda" placeholder="Buscar..." value={b} onChange={e=>setB(e.target.value)} style={{ width:"100%",marginBottom:"12px" }}/><div style={{ display:"flex",flexDirection:"column",gap:"6px",maxHeight:"400px",overflowY:"auto" }}>{f.map(c=>(<button key={c.id} onClick={()=>onSeleccionar(c)} style={{ padding:"12px 14px",background:seleccionado?.id===c.id?color+"20":"#1a1a1a",border:"1px solid "+(seleccionado?.id===c.id?color:"#2a2a2a"),borderRadius:"8px",color:seleccionado?.id===c.id?color:"#9ca3af",cursor:"pointer",textAlign:"left",fontFamily:"Inter, sans-serif",fontWeight:seleccionado?.id===c.id?700:500,fontSize:"0.875rem" }}>{c.nombre} {c.apellido}</button>))}{f.length===0&&<div style={{ textAlign:"center",padding:"20px",color:"#4b5563",fontSize:"0.875rem" }}>Sin resultados.</div>}</div></div></div>)}

function SeccionPuntos({ clientes }) {
  const [sel, setSel] = useState(null)

  function exportarCampana() {
    const ENCABEZADO = "Nombre,Apellido,Puntos,USD Beneficio,Mensaje"
    const filas = clientes.map(c => {
      const pts = calcularTotalPuntos(c)
      const usd = calcularDescuentoUSD(pts)
      const nombre = c.nombre || ""
      const msg = pts >= 50
        ? `Hola, ${nombre} 👋\nQuería contarte que actualmente tenés ${pts} puntos acumulados en Low Travel. 🎉\nEso equivale a un beneficio de USD ${usd} para usar en tu próximo viaje. 💰✈️\n¿Ya tienen pensado qué les gustaría hacer en sus próximas vacaciones? 🌴`
        : `Hola, ${nombre} 👋\nQuería contarte que ya tenés ${pts} puntos acumulados en Low Travel. ¡Seguís sumando! 🌟\n¿Ya tienen pensado qué les gustaría hacer en sus próximas vacaciones? 🌴`
      return [
        `"${nombre}"`,
        `"${c.apellido || ""}"`,
        pts,
        usd,
        `"${msg.replace(/"/g, '""')}"`,
      ].join(",")
    })
    const csv = [ENCABEZADO, ...filas].join("\n")
    const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" })
    const url  = URL.createObjectURL(blob)
    const a    = document.createElement("a")
    a.href     = url
    a.download = `campana_puntos_${new Date().toISOString().slice(0, 10)}.csv`
    a.click()
    URL.revokeObjectURL(url)
  }

  return (
    <div>
      <div className="admin__seccion-header">
        <div>
          <div className="admin__seccion-titulo">Puntos</div>
          <div className="admin__seccion-sub">Desglose y carga manual por cliente</div>
        </div>
        <button onClick={exportarCampana} style={{ padding:"10px 18px", background:"#f59e0b", border:"none", borderRadius:"8px", color:"#0a0a0a", fontFamily:"Inter, sans-serif", fontWeight:700, fontSize:"0.875rem", cursor:"pointer", whiteSpace:"nowrap" }}>
          📤 Exportar campaña CSV
        </button>
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"280px 1fr", gap:"24px", alignItems:"start" }}>
        <SelectorCliente clientes={clientes} seleccionado={sel} onSeleccionar={setSel} colorActivo="#f59e0b"/>
        <div>
          {sel
            ? <CargarPuntos clienteId={sel.id} clienteNombre={sel.nombre + " " + sel.apellido}/>
            : <div className="admin__card"><div className="admin__empty"><div className="admin__empty-icono">⭐</div><div className="admin__empty-texto">Selecciona un cliente.</div></div></div>
          }
        </div>
      </div>
    </div>
  )
}

function SeccionDocumentos({clientes}){const [sel,setSel]=useState(null);return(<div><div className="admin__seccion-header"><div className="admin__seccion-titulo">Documentos</div><div className="admin__seccion-sub">Subir vouchers por cliente</div></div><div style={{ display:"grid",gridTemplateColumns:"280px 1fr",gap:"24px",alignItems:"start" }}><SelectorCliente clientes={clientes} seleccionado={sel} onSeleccionar={setSel}/><div>{sel?<SubirVoucher clienteId={sel.id} clienteNombre={sel.nombre+" "+sel.apellido} onSubido={()=>{}}/>:<div className="admin__card"><div className="admin__empty"><div className="admin__empty-icono">📄</div><div className="admin__empty-texto">Selecciona un cliente.</div></div></div>}</div></div></div>)}

function SeccionImportar({onImportado}){const [tab,setTab]=useState("clientes");return(<div><div className="admin__seccion-header"><div className="admin__seccion-titulo">Importar datos</div><div className="admin__seccion-sub">Migracion masiva desde Google Sheets via CSV</div></div><div style={{ display:"flex",gap:"8px",marginBottom:"24px" }}>{[{id:"clientes",label:"Clientes"},{id:"viajes",label:"Viajes"}].map(t=>(<button key={t.id} onClick={()=>setTab(t.id)} style={{ padding:"10px 20px",background:tab===t.id?"#3b82f6":"#1a1a1a",border:"1px solid "+(tab===t.id?"#3b82f6":"#3a3a3a"),borderRadius:"8px",color:tab===t.id?"white":"#9ca3af",fontFamily:"Inter, sans-serif",fontWeight:700,cursor:"pointer" }}>{t.label}</button>))}</div><div style={{ maxWidth:"760px" }}>{tab==="clientes"?<ImportadorCSV onImportado={onImportado}/>:<ImportadorViajes onImportado={onImportado}/>}</div></div>)}

// Caché de sesión — persiste mientras la pestaña esté abierta
let _cache = null // { clientes, viajes, viajesPorCliente, emailsUsuarios, cargadoEn }

// ─────────────────────────────────────────────────
// Admin principal
// ─────────────────────────────────────────────────
export default function Admin() {
  const { user }=useAuth()
  const [seccionActiva,setSeccionActiva]=useState("resumen")
  const [clientes,setClientes]=useState([])
  const [viajes,setViajes]=useState([])
  const [viajesPorCliente,setViajesPorCliente]=useState({})
  const [emailsUsuarios,setEmailsUsuarios]=useState({})   // id_cliente -> email
  const [usuariosWeb,setUsuariosWeb]=useState([])
  const [loading,setLoading]=useState(true)
  const [toastEmails,setToastEmails]=useState([])         // mensajes del toast

  const [modalEditarCliente,setModalEditarCliente]=useState(null)
  const [modalNuevoCliente,setModalNuevoCliente]=useState(false)
  const [modalViaje,setModalViaje]=useState(null)

  const emailsEnviadosRef=useRef(new Set()) // IDs de viajes ya notificados en esta sesion

  const navItems = [
  { id: "resumen", icono: "📊", label: "Resumen" },
  { id: "clientes", icono: "👥", label: "Clientes" },
  { id: "viajes", icono: "✈️", label: "Viajes" },
  { id: "agenda", icono: "📅", label: "Agenda" },
  { id: "cumpleanos", icono: "🎂", label: "Cumpleaños" },
  { id: "puntos", icono: "⭐", label: "Puntos" },
  { id: "documentos", icono: "📄", label: "Documentos" },
  { id: "vincular", icono: "🔗", label: "Vincular" },
  { id: "importar", icono: "📥", label: "Importar" },
  { id: "estadisticas", icono: "📈", label: "Estadisticas" },
  { id:"configuracion", icono:"⚙️", label:"Configuracion" }
];

async function cargarDatos(forzar = false) {
  if (_cache && !forzar) {
    setClientes(_cache.clientes)
    setViajes(_cache.viajes)
    setViajesPorCliente(_cache.viajesPorCliente)
    setEmailsUsuarios(_cache.emailsUsuarios)
    setUsuariosWeb(_cache.usuariosWeb || [])
    setLoading(false)
    return { clientesData:_cache.clientes, viajesAll:_cache.viajes, porCliente:_cache.viajesPorCliente }
  }

  try {
    const [clientesSnap, webSnap, viajesSnap] = await Promise.all([
      getDocs(collection(db, "usuarios_sheets")),
      getDocs(collection(db, "usuarios_web")),
      getDocs(collectionGroup(db, "viajes")),
    ])

    const clientesData = clientesSnap.docs.map(d => ({ id: d.id, ...d.data() }))
    setClientes(clientesData)

    const webData = webSnap.docs.map(d => ({ uid: d.id, ...d.data() }))
    setUsuariosWeb(webData)

    const emailMap = {}
    webData.forEach(u => {
      if (u.id_cliente_asociado && u.email)
        emailMap[u.id_cliente_asociado] = u.email
    })
    setEmailsUsuarios(emailMap)

    const clienteMap = {}
    clientesData.forEach(c => { clienteMap[c.id] = c })

    const viajesAll = []
    const porCliente = {}
    viajesSnap.docs.forEach(d => {
      const clienteId = d.ref.parent.parent.id
      const cliente   = clienteMap[clienteId]
      const viaje = {
        id:             d.id,
        cliente_id:     clienteId,
        cliente_nombre: cliente ? (cliente.nombre_completo || ((cliente.nombre||"")+" "+(cliente.apellido||"")).trim() || "—") : "—",
        cliente_origen: cliente?.origen || cliente?.ciudad || "",
        ...d.data(),
      }
      viajesAll.push(viaje)
      if (!porCliente[clienteId]) porCliente[clienteId] = []
      porCliente[clienteId].push(viaje)
    })
    clientesData.forEach(c => { if (!porCliente[c.id]) porCliente[c.id] = [] })

    setViajes(viajesAll)
    setViajesPorCliente(porCliente)

    _cache = { clientes:clientesData, viajes:viajesAll, viajesPorCliente:porCliente, emailsUsuarios:emailMap, usuariosWeb:webData, cargadoEn:new Date() }

    return { clientesData, viajesAll, porCliente }
  } catch(e) {
    console.error("Error cargando datos:", e)
  } finally {
    setLoading(false)
  }
}

  // ── Al cargar: revisar viajes en las proximas 24hs ──
  async function verificarEmailsCheckin(viajesAll, clientesData) {
    const ahora=new Date()
    const en24hs=new Date(ahora.getTime()+24*60*60*1000)

    const pendientes=viajesAll.filter(v=>{
      if (!v.fecha_salida||v.estado==="cancelado") return false
      if (v.email_admin_enviado) return false                    // ya enviado antes
      if (emailsEnviadosRef.current.has(v.id)) return false      // ya enviado esta sesion
      const salida = parsearFecha(v.fecha_salida)
      return salida>=ahora && salida<=en24hs
    })

    if (pendientes.length===0) return

    const clienteMap={}
    clientesData.forEach(c=>{clienteMap[c.id]=c})

    const enviados=[]
    for (const v of pendientes) {
      const cliente=clienteMap[v.cliente_id]
      if (!cliente) continue

      const ok=await enviarEmailAdminCheckin({
        clienteNombre: cliente.nombre+" "+cliente.apellido,
        destino:       v.destino,
        aerolinea:     v.aerolinea,
        fechaSalida:   formatFecha(v.fecha_salida),
        fechaRegreso:  formatFecha(v.fecha_regreso),
        hotel1:        v.hotel1,
        hotel2:        v.hotel2,
        pax:           v.pax,
        asistencia:    v.asistencia,
      })

      if (ok) {
        emailsEnviadosRef.current.add(v.id)
        enviados.push(cliente.nombre+" "+cliente.apellido+" — "+v.destino)
        // Marcar en Firestore para no re-enviar
        await updateDoc(doc(db,"usuarios_sheets",v.cliente_id,"viajes",v.id),{ email_admin_enviado:true })
      }
    }

    if (enviados.length>0) setToastEmails(enviados)
  }

  useEffect(()=>{
    cargarDatos().then(resultado=>{
      if (resultado?.viajesAll&&resultado?.clientesData) {
        verificarEmailsCheckin(resultado.viajesAll,resultado.clientesData)
      }
    })
  },[])

  async function handleAsignarPuntosCumple(cliente){
    const hoy=new Date()
    try{await updateDoc(doc(db,"usuarios_sheets",cliente.id),{puntos_cumpleanos:(cliente.puntos_cumpleanos||0)+50,cumple_anio:hoy.getFullYear(),ultimo_cambio_puntos:hoy,cambio_por:user?.email});setClientes(p=>p.map(c=>c.id===cliente.id?{...c,puntos_cumpleanos:(c.puntos_cumpleanos||0)+50,cumple_anio:hoy.getFullYear()}:c))}catch(e){console.error(e)}
  }

  async function handleConfirmarCheckin(cliente, viaje) {
    try {
      await updateDoc(doc(db,"usuarios_sheets",cliente.id,"viajes",viaje.id),{checkin_confirmado:true,checkin_fecha:new Date()})
      setViajesPorCliente(p=>({...p,[cliente.id]:(p[cliente.id]||[]).map(v=>v.id===viaje.id?{...v,checkin_confirmado:true}:v)}))
      setViajes(p=>p.map(v=>v.id===viaje.id&&v.cliente_id===cliente.id?{...v,checkin_confirmado:true}:v))

      // EMAIL al cliente con todos los datos del viaje
      const emailCliente=emailsUsuarios[cliente.id]
      enviarEmailClienteCheckin({
        clienteNombre: cliente.nombre+" "+cliente.apellido,
        clienteEmail:  emailCliente,
        destino:       viaje.destino,
        aerolinea:     viaje.aerolinea,
        fechaSalida:   formatFecha(viaje.fecha_salida),
        fechaRegreso:  formatFecha(viaje.fecha_regreso),
        noches:        viaje.noches,
        pax:           viaje.pax,
        hotel1:        viaje.hotel1,
        hotel2:        viaje.hotel2,
        incluye:       viaje.incluye,
        asistencia:    viaje.asistencia,
      })
    } catch(e){console.error(e)}
  }

  async function handleConfirmarCheckout(cliente, viaje) {
    try {
      await updateDoc(doc(db,"usuarios_sheets",cliente.id,"viajes",viaje.id),{checkout_confirmado:true,checkout_fecha:new Date()})
      setViajesPorCliente(p=>({...p,[cliente.id]:(p[cliente.id]||[]).map(v=>v.id===viaje.id?{...v,checkout_confirmado:true}:v)}))
      setViajes(p=>p.map(v=>v.id===viaje.id&&v.cliente_id===cliente.id?{...v,checkout_confirmado:true}:v))
    } catch(e){console.error(e)}
  }

  function handleClienteGuardado(clienteActualizado){
    if(clienteActualizado===null){setClientes(p=>p.filter(c=>c.id!==modalEditarCliente.id));setViajesPorCliente(p=>{const n={...p};delete n[modalEditarCliente.id];return n});setViajes(p=>p.filter(v=>v.cliente_id!==modalEditarCliente.id))}
    else{setClientes(p=>p.map(c=>c.id===clienteActualizado.id?clienteActualizado:c))}
  }

  function handleNuevoClienteCreado(nuevoCliente){setClientes(p=>[...p,nuevoCliente]);setViajesPorCliente(p=>({...p,[nuevoCliente.id]:[]}));setModalNuevoCliente(false);setModalViaje({cliente:nuevoCliente,viaje:null})}

  function handleViajeGuardado(viaje,esNuevo){
    if(viaje._eliminado){setViajes(p=>p.filter(v=>!(v.id===viaje.id&&v.cliente_id===viaje.cliente_id)));setViajesPorCliente(p=>({...p,[viaje.cliente_id]:(p[viaje.cliente_id]||[]).filter(v=>v.id!==viaje.id)}));return}
    if(esNuevo){setViajes(p=>[...p,viaje]);setViajesPorCliente(p=>({...p,[viaje.cliente_id]:[...(p[viaje.cliente_id]||[]),viaje]}))}
    else{setViajes(p=>p.map(v=>v.id===viaje.id&&v.cliente_id===viaje.cliente_id?{...v,...viaje}:v));setViajesPorCliente(p=>({...p,[viaje.cliente_id]:(p[viaje.cliente_id]||[]).map(v=>v.id===viaje.id?{...v,...viaje}:v)}))}
  }

  function abrirNuevaVenta(clientePredefinido){if(clientePredefinido)setModalViaje({cliente:clientePredefinido,viaje:null});else setModalViaje("selector")}

  if(loading)return(<div className="admin" style={{ display:"flex",alignItems:"center",justifyContent:"center",minHeight:"60vh" }}><div style={{ textAlign:"center",color:"#6b7280" }}><div style={{ fontSize:"2rem",marginBottom:"12px" }}>⚙️</div><div>Cargando panel admin...</div></div></div>)

  return(
    <div className="admin">
      {/* Toast emails */}
      {toastEmails.length>0&&<ToastEmailsEnviados emails={toastEmails} onCerrar={()=>setToastEmails([])}/>}

      {modalNuevoCliente&&<ModalNuevoCliente onGuardado={handleNuevoClienteCreado} onCerrar={()=>setModalNuevoCliente(false)}/>}
      {modalEditarCliente&&<ModalEditarCliente cliente={modalEditarCliente} onGuardado={handleClienteGuardado} onCerrar={()=>setModalEditarCliente(null)}/>}
      {modalViaje==="selector"&&<SelectorClienteVenta clientes={clientes} onSeleccionar={c=>c?setModalViaje({cliente:c,viaje:null}):setModalViaje(null)} onCrearNuevo={()=>{setModalViaje(null);setModalNuevoCliente(true)}}/>}
      {modalViaje&&modalViaje!=="selector"&&<ModalViaje clienteId={modalViaje.cliente.id} clienteNombre={modalViaje.cliente.nombre+" "+modalViaje.cliente.apellido} clienteOrigen={modalViaje.cliente.origen||modalViaje.cliente.ciudad||""} clienteCuil={modalViaje.cliente.cuil||""} clienteTelefono={modalViaje.cliente.telefono||""} clienteEmail={modalViaje.cliente.email||""} clientes={clientes} viajeInicial={modalViaje.viaje} onGuardado={handleViajeGuardado} onCerrar={()=>setModalViaje(null)}/>}
      <div className="admin__layout">
        <aside className="admin__sidebar">
          <div className="admin__sidebar-titulo">Panel de control</div>
          {navItems.map(item=>(<button key={item.id} className={"admin__nav-item"+(seccionActiva===item.id?" active":"")} onClick={()=>setSeccionActiva(item.id)}><span className="admin__nav-icono">{item.icono}</span>{item.label}</button>))}
          <div style={{ marginTop:"auto",paddingTop:"16px",borderTop:"1px solid #1e3a5f",display:"flex",flexDirection:"column",gap:"6px" }}>
            <button onClick={()=>abrirNuevaVenta(null)} style={{ width:"100%",padding:"10px 14px",background:"#3b82f620",border:"1px solid #3b82f640",borderRadius:"8px",color:"#3b82f6",fontFamily:"Inter, sans-serif",fontWeight:700,fontSize:"0.875rem",cursor:"pointer" }}>+ Nueva venta</button>
            <button onClick={()=>setModalNuevoCliente(true)} style={{ width:"100%",padding:"10px 14px",background:"#10b98115",border:"1px solid #10b98130",borderRadius:"8px",color:"#10b981",fontFamily:"Inter, sans-serif",fontWeight:700,fontSize:"0.875rem",cursor:"pointer" }}>+ Nuevo cliente</button>
            <button
              onClick={() => cargarDatos(true)}
              style={{ width:"100%", padding:"10px 14px", background:"transparent", border:"1px solid #1e3a5f", borderRadius:"8px", color:"#4b5563", fontFamily:"Inter, sans-serif", fontWeight:600, fontSize:"0.8rem", cursor:"pointer", textAlign:"center" }}
            >
              🔄 Actualizar datos
              {_cache?.cargadoEn && (
                <span style={{ display:"block", fontSize:"0.68rem", color:"#374151", marginTop:2 }}>
                  {_cache.cargadoEn.toLocaleTimeString("es-AR",{hour:"2-digit",minute:"2-digit"})}
                </span>
              )}
            </button>
          </div>
        </aside>
        <main className="admin__contenido">
          {seccionActiva==="resumen"      &&<SeccionResumen      clientes={clientes} viajes={viajes} viajesPorCliente={viajesPorCliente} usuariosWeb={usuariosWeb} onAsignarPuntos={handleAsignarPuntosCumple} onCheckin={handleConfirmarCheckin} onCheckout={handleConfirmarCheckout} onIrACumpleanos={() => setSeccionActiva("cumpleanos")}/>}
          {seccionActiva==="clientes"     &&<SeccionClientes     clientes={clientes} viajesPorCliente={viajesPorCliente} onEditarCliente={setModalEditarCliente} onNuevaVenta={abrirNuevaVenta}/>}
          {seccionActiva==="viajes"       &&<SeccionViajes       viajes={viajes} onEditarViaje={v=>setModalViaje({cliente:clientes.find(c=>c.id===v.cliente_id)||{id:v.cliente_id,nombre:v.cliente_nombre?.split(" ")[0]||"",apellido:v.cliente_nombre?.split(" ").slice(1).join(" ")||""},viaje:v})} onNuevaVenta={abrirNuevaVenta}/>}          {seccionActiva==="agenda"       &&<SeccionAgenda       viajes={viajes} clientes={clientes} viajesPorCliente={viajesPorCliente} onCheckin={handleConfirmarCheckin}/>}
          {seccionActiva==="cumpleanos"   &&<SeccionCumpleanos   clientes={clientes} onAsignarPuntos={handleAsignarPuntosCumple}/>}
          {seccionActiva==="puntos"       &&<SeccionPuntos       clientes={clientes}/>}
          {seccionActiva==="documentos"   &&<SeccionDocumentos   clientes={clientes}/>}
          {seccionActiva==="vincular"     &&<SeccionVincular     clientes={clientes}/>}
          {seccionActiva==="importar"     &&<SeccionImportar     onImportado={cargarDatos}/>}
          {seccionActiva==="estadisticas" && <SeccionEstadisticas viajes={viajes} clientes={clientes} viajesPorCliente={viajesPorCliente}/>}
          {seccionActiva==="configuracion" && <SeccionConfiguracion />}
        </main>
      </div>
    </div>
  )
}
